import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/browser';
import { AppModule } from './app/app.module';
import { AppService } from './app/services/app.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  window.console.log = () => {};
  window.console.debug = () => {};
  window.console.warn = () => {};
  window.console.info = () => {};
  window.console.error = () => {};

  let dist = 'web';
  if (Capacitor.isNativePlatform()) {
    dist = 'mobile';
  }

  Sentry.init({
    dsn: 'https://6349bd2078c1413e83997e8344d0cf47@o4504451572367360.ingest.sentry.io/4504604748611584',
    release: AppService.APP_VERSION,
    dist: dist,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
